//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { isObject, map } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const classActivitiesInitial = [];
function mapToGraphic  (data){
    return map(data,k=>{
        if (k && k.data && k.data.activity_type == 'graphic_organizer') {
            if(!k.data.page){
                k.data.page = k.assigned_on_page
            }
        }
        return k;
    })
}
export const classActivities = (state = classActivitiesInitial, action) => {
    switch (action.type) {
        case ActionTypes.classActivities.updateClassActivitiesById:
            return mapToGraphic(state.map(x => {
                if (x.id === action.payload.id) {
                    return { ...x, ...action.payload };
                } else {
                    return x;
                }
            }));
        case ActionTypes.assignmenent.updateCustomAssignmentSuccess:
            return state.map(x => {
                if (x.activityId === action.payload.id) {
                    return {
                        ...x,
                        data: {...action.payload }
                    };
                } else {
                    return x;
                }
            });
        case ActionTypes.classActivities.listClassActivitiesSuccess:
            return mapToGraphic(action.payload);
        case ActionTypes.classActivities.createClassActivitySuccess:
            return mapToGraphic([action.payload, ...state]);
        case ActionTypes.classActivities.deleteClassActivitySuccess:
            return state.filter(x => x.id !== action.payload.id && x.activityId !== action.payload.id);
        case ActionTypes.classActivities.deleteMultiClassActivitySuccess:
            const { id, classIds, checkClassId } = action.payload;
            if(checkClassId){
                return state.filter(x => x.id !== id && x.activityId !== id);
            }
            return state.map(item => {
                if (item.id === id || item.activityId === id) {
                  return {
                    ...item,
                    classes: item.classes.filter(c => !classIds.includes(c.id))
                  };
                }
                return item;
            });
        case ActionTypes.classActivities.updateClassActivitySuccess:
            return mapToGraphic(state.map(x => {
                if (x.id === action.payload.id) {
                    return { ...x, ...action.payload };
                } else {
                    return x;
                }
            }));
        case ActionTypes.classActivities.updateClassActivitiesFromSchoologySocket: {
            const { assignments, currentClassId } = action.payload;
            if (!assignments?.length || !currentClassId) return state;
            const idsToMerge = new Map();
            assignments.forEach((item) => {
                if (item.classId !== currentClassId || !item.activityId || !item.updatedData?.id) return;
                const u = item.updatedData;
                idsToMerge.set(u.id, {
                    id: u.id,
                    sAssignmentId: u.sAssignmentId,
                    deleted_from_integration: u.deleted_from_integration,
                    queue_status: u.queue_status,
                    grade_type: u.grade_type,
                    weightage: u.weightage,
                    max_point: u.max_point
                });
            });
            if (idsToMerge.size === 0) return state;
            return mapToGraphic(state.map(x => {
                const merge = idsToMerge.get(x.id);
                return merge ? { ...x, ...merge } : x;
            }));
        }
        case ActionTypes.classActivities.listClassActivitiesFail:
        case ActionTypes.classActivities.createClassActivityFail:
        case ActionTypes.classActivities.deleteClassActivityFail:
        case ActionTypes.classActivities.uodateClassActivityFail:
        case ActionTypes.classActivities.createDeactivateByStudent:  
        return state.map(data => {
            if (data?.id === action.payload.assignmentId) {
                return {
                    ...data,
                    deactivated_student: action.payload.deactivateStudent
                };
            }
            return data;
        });
        case ActionTypes.classActivities.listClassActivitiesForStudentWithIds:
            if(action.payload?.isDeleted){
                const { activityIds } = action.payload;
                if(activityIds?.length > 0){
                    return state.filter(data => !activityIds.includes(data?.activityId));
                }
                return state;
            }
            const haveSome = state.some(data => data?.id === action.payload?.id);
            if(haveSome){
                return state.map(data => {
                    if(data?.id === action.payload?.id){
                        return action.payload;
                    }
                    return data;
                });
            }else{
                const newData = [...state, action.payload];
                return newData;
            }
        default:
            return state;
    }
};
